import { render } from "./TabsCompat.vue?vue&type=template&id=687575ab"
import script from "./TabsCompat.vue?vue&type=script&lang=js"
export * from "./TabsCompat.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__